var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19.481 19.481",
    "aria-labelledby": "packageIcon packageDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.258 5.656l-2.247-4.5A2.087 2.087 0 0015.139 0H4.341A2.087 2.087 0 002.47 1.155L.223 5.656A2.087 2.087 0 000 6.589v10.8a2.087 2.087 0 002.087 2.087h15.306a2.087 2.087 0 002.087-2.087v-10.8a2.087 2.087 0 00-.222-.933zm-3.479-3.882l1.878 3.792h-4.591l-1.044-4.175h3.117a.7.7 0 01.626.383zM7.653 6.957h4.174v4.87l-1.67-1.252a.7.7 0 00-.835 0l-1.67 1.252zm2.936-5.566l1.044 4.174-3.889 4.87.522-4.174zm-6.874.383a.7.7 0 01.626-.383l2.526 4.87-.522-.695H1.823zm14.374 15.619a.7.7 0 01-.7.7H2.087a.7.7 0 01-.7-.7V6.957h4.87v6.262a.678.678 0 001.078.557L9.74 12l2.366 1.774a.7.7 0 00.417.139.633.633 0 00.313-.077.7.7 0 00.383-.619v-6.26h4.87z"
  })));
}

export default SvgPackage;